
const observer = new MutationObserver((mutations) => {
  const newInput = document.querySelector('input[type="number"]');
  if (newInput && !newInput.dataset.bound) {
    newInput.addEventListener('change', validateMax);
  }
});
observer.observe(document.querySelector('.product__info-wrapper'), { childList: true, subtree: true });

function validateMax() {
  if (this.value != '') {
    if (parseInt(this.value) < parseInt(this.min)) {
      this.value = this.min;
    }
    if (parseInt(this.value) > parseInt(this.max)) {
      this.value = this.max;
    }
  }
}
